import styled from 'styled-components';

export const SocialSection = styled.div`
  text-align: center;
  cursor: pointer;

  @media (max-width: 720px) {
    padding-bottom: 80px;
  }
`;

export const Icons = styled.div`
  img {
    width: 32px;
    height: 32px;
    margin: 0 10px;
  }
`;
export const PrivacyPolicy = styled.div`
  font-size: 13px;
  padding: 10px 0;
  color: #606060;
  cursor: pointer;
`;

export const CopyRights = styled.div`
  font-size: 11px;
  color: rgb(0 0 0 / 44%);
  padding: 10px 4px 16px;
`;

export const SocialImagesStyle = styled.div`
  display: flex;
  column-gap: 3px;
`;
